import fontStacks from './fontStacks';

const topNewsStyle = Object.freeze({
  fontFamily: fontStacks.alt,
  href: '/misc/breakingnews',
});

export default topNewsStyle;
